import type { DetailsHTMLAttributes, ReactNode } from 'react';
import styles from './Disclosure.module.css';

export function Disclosure({
  title,
  children,
  className,
  ...rest
}: Omit<DetailsHTMLAttributes<HTMLDetailsElement>, 'children'> & {
  title: ReactNode;
  children: ReactNode;
}): ReactNode {
  return (
    <details
      className={[styles.disclosure, className].filter(Boolean).join(' ')}
      {...rest}
    >
      <summary className={styles.summary}>
        <span>{title}</span>
        <span className={styles.indicator} aria-hidden="true" />
      </summary>
      <div className={styles.content}>{children}</div>
    </details>
  );
}
